enum ButtonVariants {
  Contained = "contained",
  Outlined = "outlined",
  Text = "text",
}

export { ButtonVariants };
